import type { BrandColor } from '@app-types/color'
import type { HorizontalSide } from '@app-types/styles'
import type { AuthorProps } from '@components/article-byline'
import { ContentfulImage } from '@components/contentful-image'
import { Quote as QuoteIcon } from '@components/icons/quote'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './quote.module.scss'

/**
 * Displays a blockquote with author.
 */
export const Quote: FunctionComponent<Props> = ({
    color = 'step-cyanora',
    alignment = 'right',
    text,
    author,
    ...rest
}) => (
    <blockquote
        {...rest}
        className={classNames(styles.quote, styles[color], styles[alignment])}
    >
        {author?.avatar && (
            <ContentfulImage
                className={styles.avatar}
                url={author?.avatar.source}
                alt={author.name}
                contentType={author?.avatar.contentType}
                sizes='120px'
            />
        )}

        <div
            className={classNames(styles.text, {
                [styles['text-with-avatar']]: !!author?.avatar,
                [styles[`text-${alignment}`]]: !!author?.avatar,
                [styles['text']]: !author?.avatar,
            })}
        >
            <QuoteIcon
                className={classNames(styles.icon, styles[`fill-${color}`])}
            />
            {text}
            {!author?.avatar && author?.name && (
                <div className={styles.author}>&#8212; {author.name}</div>
            )}
        </div>
    </blockquote>
)

type Props = {
    /** Author of the quote. */
    author?: AuthorProps
    text: string
    color?: BrandColor
    alignment: HorizontalSide
}
